module.exports = __webpack_public_path__ + "media/images/request-not-success-7995a0a1.svg";